import React, { Component } from 'react'
import { get } from "lodash"

import { checkIsValidBodyZone } from "./static.bodyZoneData"
import { withStepsState } from "../../../shared/containers/containerStepsState"
import ButtonFill from "../../../shared/items/controls/buttonFill"
import { updateStepData } from "./../../../actions/stepsStateActions"
import { store } from "./../../../store"
import STEPS_NAMES_BY_KEY from './../../../utils/stepsNamesByKey'

class BodyZoneNextStepButton extends Component {
  constructor() {
    super();

    this.goNext = this.goNext.bind(this);
  }

  componentDidUpdate() {
    const { data, onSetSuccessValidate, onSetFailValidate } = this.props

    if (checkIsValidBodyZone(data) && !get(data, ["bodyZone", "isValid"], false))
      onSetSuccessValidate("bodyZone")

    if (!checkIsValidBodyZone(data) && get(data, ["bodyZone", "isValid"], false))
      onSetFailValidate("bodyZone")
  }

  goNext() {
    this.props.onToNextStep();

    let zones = [];

    if (this.props.data.bodyZone.absCore) zones.push('Abs & Core');
    if (this.props.data.bodyZone.armsBack) zones.push('Arms & Back');
    if (this.props.data.bodyZone.legs) zones.push('Legs & Glutes');

    window.dataLayer.push({
      'event': 'onboarding_question',
      'quiz_question': STEPS_NAMES_BY_KEY['bodyZone'],
      'quiz_answer': zones,
    });
  }

  render() {
    return (
      <ButtonFill disabled={!get(this.props.  data, ["bodyZone", "isValid"], false)} onClick={this.goNext}>
        {this.props.children}
      </ButtonFill>
    )
  }
}

export default withStepsState(BodyZoneNextStepButton)